import React,{useState} from 'react'
import { getMasterCardUrl } from '../../actions/MasterCardAction'
import { salesforceSendFormNumber } from '../../actions/StudentAction'

const MasterCard = ({paymentConfig,userDetail,selectedMethodFeeDetail}) => {
    const {form_num,name,id} = userDetail !==undefined && userDetail
    const {instData} = selectedMethodFeeDetail !==undefined && selectedMethodFeeDetail
    const [loading,setLoading] = useState(false)

     const masterCardHandle = () => {
        setLoading(true)
        const data = {
          fno: form_num,
	        amount:parseFloat(instData?.amount).toFixed(2) ,
          gateway_id: paymentConfig.id,
	        name: name,
	        cancel_url:`${process.env.REACT_APP_PUBLIC_URL}/student/payment-failed/${id}/${selectedMethodFeeDetail?.pay_type}/${instData?.installment_number}/`,
	        success_url:`${process.env.REACT_APP_PUBLIC_URL}/student/payment-successfull/${id}/${selectedMethodFeeDetail?.pay_type}/${instData?.installment_number}/?payment=` 
        }

        getMasterCardUrl(data).then((res) => {
            setLoading(true)
            if(res.status){
                setLoading(false)
                salesforceSendFormNumber({form_num:form_num,status:'payment_initiated'})
                window.location.href=` ${process.env.REACT_APP_API_URL}/api/getmastercardSessionid/${res.session_id}`
            }
        })
    }
  return (
    <div>
        {loading ? <button type="submit" disabled className="banktransfer_btn">
                <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
                Processing ...</button> : 
                <>
           <button 
           onClick={masterCardHandle} 
           className='banktransfer_btn'>Master Card</button>
           {/* <button className='banktransfer_btn'>Master Card</button> */}
        </>
        }
        </div>
  )
}

export default MasterCard